import { useEffect } from 'react';
import { units } from '@ui/css';
import { makeSelectors, combineTokens, makeScaleableToken } from '@utils/css';

const scrollbarSelectors = makeSelectors({
  visible: "visible-scrollbars"
});
const scrollbarTokens = combineTokens("--scrollbar", {
  width: [units.px(0), makeScaleableToken]
});

/**
 * apply custom css properties that can only be calculated at runtime when the
 * component mounts.
 */
function useScrollbarProperties() {
  useEffect(() => {
    const onUpdate = () => {
      const scrollbarWidth = calculateScrollbarWidth();
      document.documentElement.classList.toggle(scrollbarSelectors.visible.className, scrollbarWidth > 0);
      document.documentElement.style.setProperty(scrollbarTokens.width.propName, `${scrollbarWidth}px`);
    };
    onUpdate();
    setTimeout(onUpdate, 100);
  }, []);
}
function calculateScrollbarWidth() {
  const calculatorNode = document.createElement("div");
  try {
    calculatorNode.style.cssText = `width: 100px; height: 100px; overflow: auto; position: absolute;`;
    calculatorNode.innerHTML = `<div style="width: 100%; height: 200%;"></div>`;
    document.body.appendChild(calculatorNode);
    return calculatorNode.offsetWidth - calculatorNode.clientWidth;
  } finally {
    calculatorNode.parentNode?.removeChild(calculatorNode);
  }
}

export { scrollbarSelectors, scrollbarTokens, useScrollbarProperties };
//# sourceMappingURL=scrollbar-properties.js.map
